<template>
    <b-table
        id="cdas"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive="sm"
        :no-local-sorting="true"
        @sort-changed="sortingChanged"
        :busy="configTable.load"
        show-empty
        > 
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Não há CDA's obtidas com os filtros de pesquisa informados.</p>
        </template>
        
        <template slot="1" slot-scope="row">
            <p class="text-left">
                {{ row.item.numeroDivida }}
            </p>
        </template>
        <template slot="2" slot-scope="row">
            <p v-for="devedor in row.item.devedores" :key="devedor.cpfCnpj" class="text-left">
                {{ devedor.nome }}
            </p>
        </template>
        <template slot="3" slot-scope="row">            
            <p v-for="devedor in row.item.devedores" :key="devedor.cpfCnpj" class="text-left">
                {{ devedor.cpfCnpj | cpfCnpj }}
            </p>
        </template>
        <template slot="4" slot-scope="row">
            <p class="text-center">
                {{ row.item.tipoCredito }}
            </p>
        </template>
        <template slot="5" slot-scope="row">
            {{ row.item.origem }}
        </template>
        <template slot="6" slot-scope="row">
            <p v-for="devedor in row.item.devedores" :key="devedor.cpfCnpj" class="text-left">
                {{ devedor.cadicms }}
            </p>
        </template>
        <template slot="7" slot-scope="row">
            <p class="text-center">
                {{ row.item.dtInscricao }}
            </p>
        </template>
        <template slot="8" slot-scope="row">
            <p class="text-right">
                {{ row.item.valor | currency }}
            </p>
        </template>
        <template slot="9" slot-scope="row">
            <p class="text-left">
                {{ row.item.comarca }}
            </p>
        </template>
        <template slot="10" slot-scope="row">
            <p class="text-center">
                {{ row.item.remessa }}
            </p>
        </template>
        <template slot="11" slot-scope="row">
            <p v-html="row.item.confirmacao" class="text-left"></p>
        </template>
        <template slot="12" slot-scope="row">
            <p class="text-center">
                {{ row.item.dtConfirmacao }}
            </p>
        </template>
        <template slot="13" slot-scope="row">
            <p v-html="row.item.retorno" class="text-left"></p>
        </template>
        <template slot="14" slot-scope="row">
            <p class="text-center">
                {{ row.item.dtRetorno }}
            </p>
        </template>
        <template slot="15" slot-scope="row">
            <p class="text-center">
                {{ row.item.dtPagamento }}
            </p>
        </template>
        <template slot="16" slot-scope="row">
            {{ row.item.carta }}
        </template>
        <template slot="17" slot-scope="row">
            <p class="text-center">
                {{ row.item.dtCarta }}
            </p>
        </template>
    </b-table>
</template>

<script>
export default {
    props: ['resultado', 'fields', 'configTable'],
    watch: {
        currentPage() {
            this.$emit('consultar');
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    methods: {      
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'numeroDivida';
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'contribuinte';
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'cpfCnpj';
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'tipoCredito';
            }
            if(ctx.sortBy == 5) {
                this.configTable.sortField = 'origem';
            }
            if(ctx.sortBy == 6) {
                this.configTable.sortField = 'cadicms';
            }
            if(ctx.sortBy == 7) {
                this.configTable.sortField = 'dataInscricao';
            }
            if(ctx.sortBy == 8) {
                this.configTable.sortField = 'valorTotal';
            }
            if(ctx.sortBy == 9) {
                this.configTable.sortField = 'comarca';
            }
            if(ctx.sortBy == 10) {
                this.configTable.sortField = 'dataEnvioProtesto';
            }
            if(ctx.sortBy == 11) {
                this.configTable.sortField = 'ocorrenciaSolucao';
            }
            if(ctx.sortBy == 12) {
                this.configTable.sortField = 'dataProtocoloT34';
            }
            if(ctx.sortBy == 13) {
                this.configTable.sortField = 'ocorrencia';
            }
            if(ctx.sortBy == 14) {
                this.configTable.sortField = 'dataOcorrencia';
            }
            if(ctx.sortBy == 15) {
                this.configTable.sortField = 'dataPagamentoParcelamento';
            }
            if(ctx.sortBy == 16) {
                this.configTable.sortField = 'carta';
            }
            if(ctx.sortBy == 17) {
                this.configTable.sortField = 'dataCarta';
            }

            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc';
            this.$emit('sortingChanged');
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}
</style>
